export const KeyEventTypes = ['keyup', 'keydown'] as const;
export declare type KeyEventType = typeof KeyEventTypes[number];
